 export const countries = [
        {
            value: '143',
            iso: '4028',
            country: 'PERÚ'
        },
        {
            country: '--'
        },
        {
            value: '1',
            iso: '5001',
            country: 'AFGANISTÁN'
        },
        {
            value: '2',
            iso: '6001',
            country: 'ALBANIA'
        },
        {
            value: '3',
            iso: '6002',
            country: 'ALEMANIA'
        },
        {
            value: '4',
            iso: '6003',
            country: 'ANDORRA'
        },
        {
            value: '5',
            iso: '3001',
            country: 'ANGOLA'
        },
        {
            value: '6',
            iso: '4001',
            country: 'ANTIGUA BARBUDA'
        },
        {
            value: '7',
            iso: '5002',
            country: 'ARABIA SAUDITA'
        },
        {
            value: '8',
            iso: '3002',
            country: 'ARGELIA'
        },
        {
            value: '9',
            iso: '4002',
            country: 'ARGENTINA'
        },
        {
            value: '10',
            iso: '5042',
            country: 'ARMENIA'
        },
        {
            value: '11',
            iso: '7001',
            country: 'AUSTRALIA'
        },
        {
            value: '12',
            iso: '6004',
            country: 'AUSTRIA'
        },
        {
            value: '13',
            iso: '5043',
            country: 'AZERBAIYAN'
        },
        {
            value: '14',
            iso: '4003',
            country: 'BAHAMAS'
        },
        {
            value: '15',
            iso: '5003',
            country: 'BAHREIN'
        },
        {
            value: '16',
            iso: '5004',
            country: 'BANGLADESH'
        },
        {
            value: '17',
            iso: '4004',
            country: 'BARBADOS'
        },
        {
            value: '18',
            iso: '6033',
            country: 'BELARUS'
        },
        {
            value: '19',
            iso: '6005',
            country: 'BÉLGICA'
        },
        {
            value: '20',
            iso: '4005',
            country: 'BELICE'
        },
        {
            value: '21',
            iso: '3003',
            country: 'BENIN'
        },
        {
            value: '22',
            iso: '5007',
            country: 'BHUTAN'
        },
        {
            value: '23',
            iso: '4006',
            country: 'BOLIVIA'
        },
        {
            value: '24',
            iso: '6040',
            country: 'BOSNIA-HERZEGOVINA'
        },
        {
            value: '25',
            iso: '3004',
            country: 'BOTSWANA'
        },
        {
            value: '26',
            iso: '4007',
            country: 'BRASIL'
        },
        {
            value: '27',
            iso: '5006',
            country: 'BRUNEI'
        },
        {
            value: '28',
            iso: '6006',
            country: 'BULGARIA'
        },
        {
            value: '29',
            iso: '3005',
            country: 'BURKINA FASO'
        },
        {
            value: '30',
            iso: '3006',
            country: 'BURUNDI'
        },
        {
            value: '31',
            iso: '3007',
            country: 'CABO VERDE'
        },
        {
            value: '32',
            iso: '5022',
            country: 'CAMBOYA'
        },
        {
            value: '33',
            iso: '3008',
            country: 'CAMERÚN'
        },
        {
            value: '34',
            iso: '4008',
            country: 'CANADÁ'
        },
        {
            value: '35',
            iso: '3009',
            country: 'CHAD'
        },
        {
            value: '36',
            iso: '6007',
            country: 'CHECOSLOVAQUIA'
        },
        {
            value: '37',
            iso: '4009',
            country: 'CHILE'
        },
        {
            value: '38',
            iso: '5008',
            country: 'CHINA REPÚBLICA POPULAR DE'
        },
        {
            value: '39',
            iso: '5009',
            country: 'CHIPRE'
        },
        {
            value: '40',
            iso: '4010',
            country: 'COLOMBIA'
        },
        {
            value: '41',
            iso: '3021',
            country: 'COMORES'
        },
        {
            value: '42',
            iso: '3010',
            country: 'CONGO REPÚBLICA POPULAR Del'
        },
        {
            value: '43',
            iso: '5010',
            country: 'COREA REPÚBLICA DE'
        },
        {
            value: '44',
            iso: '5011',
            country: 'COREA REPÚBLICA DEMOCRÁTICAPOP'
        },
        {
            value: '45',
            iso: '3011',
            country: 'COSTA DE MARFIL'
        },
        {
            value: '46',
            iso: '4011',
            country: 'COSTA RICA'
        },
        {
            value: '47',
            iso: '6041',
            country: 'CROACIA'
        },
        {
            value: '48',
            iso: '4012',
            country: 'CUBA'
        },
        {
            value: '49',
            iso: '6008',
            country: 'DINAMARCA'
        },
        {
            value: '50',
            iso: '3012',
            country: 'DJIBOUTI'
        },
        {
            value: '51',
            iso: '4013',
            country: 'DOMINICA'
        },
        {
            value: '52',
            iso: '4014',
            country: 'ECUADOR'
        },
        {
            value: '53',
            iso: '3013',
            country: 'EGIPTO'
        },
        {
            value: '54',
            iso: '4015',
            country: 'EL SALVADOR'
        },
        {
            value: '55',
            iso: '5012',
            country: 'EMIRATOS ARABES UNIDOS'
        },
        {
            value: '56',
            iso: '6042',
            country: 'ESLOVENIA'
        },
        {
            value: '57',
            iso: '6009',
            country: 'ESPAÑA'
        },
        {
            value: '58',
            iso: '4016',
            country: 'ESTADOS UNIDOS DE AMÉRICA'
        },
        {
            value: '59',
            iso: '6034',
            country: 'ESTONIA'
        },
        {
            value: '60',
            iso: '3014',
            country: 'ETIOPÍA'
        },
        {
            value: '61',
            iso: '7006',
            country: 'FIJI'
        },
        {
            value: '62',
            iso: '5013',
            country: 'FILIPINAS'
        },
        {
            value: '63',
            iso: '6010',
            country: 'FINLANDIA'
        },
        {
            value: '64',
            iso: '6011',
            country: 'FRANCIA'
        },
        {
            value: '65',
            iso: '3015',
            country: 'GABÓN'
        },
        {
            value: '66',
            iso: '3016',
            country: 'GAMBIA'
        },
        {
            value: '67',
            iso: '5044',
            country: 'GEORGIA'
        },
        {
            value: '68',
            iso: '3017',
            country: 'GHANA'
        },
        {
            value: '69',
            iso: '4017',
            country: 'GRANADA'
        },
        {
            value: '70',
            iso: '6012',
            country: 'GRECIA'
        },
        {
            value: '71',
            iso: '4018',
            country: 'GUATEMALA'
        },
        {
            value: '72',
            iso: '4020',
            country: 'GUAYANA FRANCESA'
        },
        {
            value: '73',
            iso: '3018',
            country: 'GUINEA'
        },
        {
            value: '74',
            iso: '3020',
            country: 'GUINEA BISSAU'
        },
        {
            value: '75',
            iso: '3019',
            country: 'GUINEA ECUATORIAL'
        },
        {
            value: '76',
            iso: '4019',
            country: 'GUYANA'
        },
        {
            value: '77',
            iso: '4021',
            country: 'HAITÍ'
        },
        {
            value: '78',
            iso: '4022',
            country: 'HONDURAS'
        },
        {
            value: '79',
            iso: '6013',
            country: 'HUNGRÍA'
        },
        {
            value: '80',
            iso: '5014',
            country: 'INDIA'
        },
        {
            value: '81',
            iso: '5015',
            country: 'INDONESIA'
        },
        {
            value: '82',
            iso: '5017',
            country: 'IRÁN'
        },
        {
            value: '83',
            iso: '5016',
            country: 'IRAQ'
        },
        {
            value: '84',
            iso: '6014',
            country: 'IRLANDA'
        },
        {
            value: '85',
            iso: '6015',
            country: 'ISLANDIA'
        },
        {
            value: '86',
            iso: '7007',
            country: 'ISLAS MARSHALL'
        },
        {
            value: '87',
            iso: '7008',
            country: 'ISLAS SALOMON'
        },
        {
            value: '88',
            iso: '5019',
            country: 'ISRAEL'
        },
        {
            value: '89',
            iso: '6016',
            country: 'ITALIA'
        },
        {
            value: '90',
            iso: '3025',
            country: 'JA LIBIA'
        },
        {
            value: '91',
            iso: '4023',
            country: 'JAMAICA'
        },
        {
            value: '92',
            iso: '5020',
            country: 'JAPÓN'
        },
        {
            value: '93',
            iso: '5021',
            country: 'JORDANIA'
        },
        {
            value: '94',
            iso: '5045',
            country: 'KAZAJSTAN'
        },
        {
            value: '95',
            iso: '3022',
            country: 'KENYA'
        },
        {
            value: '96',
            iso: '5046',
            country: 'KIRGUISTAN'
        },
        {
            value: '97',
            iso: '7009',
            country: 'KIRIBATI'
        },
        {
            value: '98',
            iso: '5023',
            country: 'KUWAIT'
        },
        {
            value: '99',
            iso: '5024',
            country: 'LAO REPÚBLICA DEMOCRÁTICA POPU'
        },
        {
            value: '100',
            iso: '3023',
            country: 'LESOTHO'
        },
        {
            value: '101',
            iso: '6035',
            country: 'LETONIA'
        },
        {
            value: '102',
            iso: '5025',
            country: 'LÍBANO'
        },
        {
            value: '103',
            iso: '3024',
            country: 'LIBERIA'
        },
        {
            value: '104',
            iso: '6017',
            country: 'LIECHTENSTEIN'
        },
        {
            value: '105',
            iso: '6036',
            country: 'LITUANIA'
        },
        {
            value: '106',
            iso: '6018',
            country: 'LUXEMBURGO'
        },
        {
            value: '107',
            iso: '6043',
            country: 'MACEDONIA REPÚBLICA DE'
        },
        {
            value: '108',
            iso: '3026',
            country: 'MADAGASCAR'
        },
        {
            value: '109',
            iso: '5026',
            country: 'MALASIA'
        },
        {
            value: '110',
            iso: '3027',
            country: 'MALAWI'
        },
        {
            value: '111',
            iso: '5018',
            country: 'MALDIVAS'
        },
        {
            value: '112',
            iso: '3028',
            country: 'MALÍ'
        },
        {
            value: '113',
            iso: '6019',
            country: 'MALTA'
        },
        {
            value: '114',
            iso: '3029',
            country: 'MARRUECOS'
        },
        {
            value: '115',
            iso: '3052',
            country: 'MAURICIO'
        },
        {
            value: '116',
            iso: '3030',
            country: 'MAURITANIA'
        },
        {
            value: '117',
            iso: '4024',
            country: 'MÉXICO'
        },
        {
            value: '118',
            iso: '7005',
            country: 'MICRONESIA ESTADOS FEDERADOS D'
        },
        {
            value: '119',
            iso: '6037',
            country: 'MOLDOVA'
        },
        {
            value: '120',
            iso: '6020',
            country: 'MÓNACO PRINCIPADO DE'
        },
        {
            value: '121',
            iso: '5027',
            country: 'MONGOLIA'
        },
        {
            value: '122',
            iso: '3031',
            country: 'MOZAMBIQUE'
        },
        {
            value: '123',
            iso: '5005',
            country: 'MYANMAR'
        },
        {
            value: '124',
            iso: '3032',
            country: 'NAMIBIA'
        },
        {
            value: '125',
            iso: '7010',
            country: 'NAURU'
        },
        {
            value: '126',
            iso: '5028',
            country: 'NEPAL'
        },
        {
            value: '127',
            iso: '4025',
            country: 'NICARAGUA'
        },
        {
            value: '128',
            iso: '3033',
            country: 'NÍGER'
        },
        {
            value: '129',
            iso: '3034',
            country: 'NIGERIA'
        },
        {
            value: '130',
            iso: '6021',
            country: 'NORUEGA'
        },
        {
            value: '131',
            iso: '7002',
            country: 'NUEVA ZELANDIA'
        },
        {
            value: '132',
            iso: '5029',
            country: 'OMÁN'
        },
        {
            value: '133',
            iso: '3099',
            country: 'OTROS PAÍSES DE AFRICA'
        },
        {
            value: '134',
            iso: '4099',
            country: 'OTROS PAÍSES DE AMÉRICA'
        },
        {
            value: '135',
            iso: '5099',
            country: 'OTROS PAÍSES DE ASIA'
        },
        {
            value: '136',
            iso: '6099',
            country: 'OTROS PAÍSES DE EUROPA'
        },
        {
            value: '137',
            iso: '7099',
            country: 'TROS PAÍSES DE OCEANÍA Y REGI'
        },
        {
            value: '138',
            iso: '6022',
            country: 'PAÍSES BAJOS (HOLANDA)'
        },
        {
            value: '139',
            iso: '5030',
            country: 'PAKISTÁN'
        },
        {
            value: '140',
            iso: '4026',
            country: 'PANAMÁ'
        },
        {
            value: '141',
            iso: '7011',
            country: 'PAPUA NUEVA GUINEA'
        },
        {
            value: '142',
            iso: '4027',
            country: 'PARAGUAY'
        },
        {
            value: '144',
            iso: '6023',
            country: 'POLONIA'
        },
        {
            value: '145',
            iso: '6024',
            country: 'PORTUGAL'
        },
        {
            value: '146',
            iso: '4029',
            country: 'PUERTO RICO'
        },
        {
            value: '147',
            iso: '5031',
            country: 'QATAR'
        },
        {
            value: '148',
            iso: '6025',
            country: 'REINO UNIDO'
        },
        {
            value: '149',
            iso: '3035',
            country: 'REPÚBLICA CENTROAFRICANA'
        },
        {
            value: '150',
            iso: '4030',
            country: 'REPÚBLICA DOMINICANA'
        },
        {
            value: '151',
            iso: '6026',
            country: 'RUMANIA'
        },
        {
            value: '152',
            iso: '6038',
            country: 'RUSIA FEDERACIÓN DE'
        },
        {
            value: '153',
            iso: '3036',
            country: 'RWANDA'
        },
        {
            value: '154',
            iso: '7003',
            country: 'SAMOA OCCIDENTAL'
        },
        {
            value: '155',
            iso: '4031',
            country: 'SAN CRISTÓBAL Y NEVIS'
        },
        {
            value: '156',
            iso: '6027',
            country: 'SAN MARINO'
        },
        {
            value: '157',
            iso: '4032',
            country: 'SAN VICENTE Y LAS GRANADINAS'
        },
        {
            value: '158',
            iso: '4033',
            country: 'SANTA LUCIA'
        },
        {
            value: '159',
            iso: '6031',
            country: 'SANTA SEDE (VATICANO)'
        },
        {
            value: '160',
            iso: '3037',
            country: 'SANTO TOME Y PRÍNCIPE'
        },
        {
            value: '161',
            iso: '3038',
            country: 'SENEGAL'
        },
        {
            value: '162',
            iso: '3039',
            country: 'SEYCHELLES'
        },
        {
            value: '163',
            iso: '3040',
            country: 'SIERRA LEONA'
        },
        {
            value: '164',
            iso: '5032',
            country: 'SINGAPUR'
        },
        {
            value: '165',
            iso: '5033',
            country: 'SIRIA'
        },
        {
            value: '166',
            iso: '3041',
            country: 'SOMALIA'
        },
        {
            value: '167',
            iso: '5034',
            country: 'SRI LANKA'
        },
        {
            value: '168',
            iso: '3043',
            country: 'SUDÁFRICA'
        },
        {
            value: '169',
            iso: '3044',
            country: 'SUDAN'
        },
        {
            value: '170',
            iso: '6028',
            country: 'SUECIA'
        },
        {
            value: '171',
            iso: '6029',
            country: 'SUIZA'
        },
        {
            value: '172',
            iso: '4034',
            country: 'SURINAME'
        },
        {
            value: '173',
            iso: '3042',
            country: 'SWAZILANDIA'
        },
        {
            value: '174',
            iso: '5035',
            country: 'TAILANDIA'
        },
        {
            value: '175',
            iso: '5036',
            country: 'TAIWAN'
        },
        {
            value: '176',
            iso: '3045',
            country: 'TANZANIA'
        },
        {
            value: '177',
            iso: '5047',
            country: 'TAYISKISTAN'
        },
        {
            value: '178',
            iso: '3046',
            country: 'TOGO'
        },
        {
            value: '179',
            iso: '7004',
            country: 'TONGA'
        },
        {
            value: '180',
            iso: '4035',
            country: 'TRINIDAD Y TOBAGO'
        },
        {
            value: '181',
            iso: '3047',
            country: 'TÚNEZ'
        },
        {
            value: '182',
            iso: '5048',
            country: 'TURKMENISTAN'
        },
        {
            value: '183',
            iso: '5037',
            country: 'TURQUÍA'
        },
        {
            value: '184',
            iso: '7012',
            country: 'TUVALU'
        },
        {
            value: '185',
            iso: '6039',
            country: 'UCRANIA'
        },
        {
            value: '186',
            iso: '3048',
            country: 'UGANDA'
        },
        {
            value: '187',
            iso: '4036',
            country: 'URUGUAY'
        },
        {
            value: '188',
            iso: '5049',
            country: 'UZBEKISTAN'
        },
        {
            value: '189',
            iso: '7013',
            country: 'VANUATU'
        },
        {
            value: '190',
            iso: '4037',
            country: 'VENEZUELA'
        },
        {
            value: '191',
            iso: '5038',
            country: 'VIET NAM'
        },
        {
            value: '192',
            iso: '5041',
            country: 'YEMEN REPÚBLICA DE'
        },
        {
            value: '193',
            iso: '6044',
            country: 'YUGOSLAVIA REPÚBLICA FEDERAL D'
        },
        {
            value: '194',
            iso: '3049',
            country: 'ZAIRE'
        },
        {
            value: '195',
            iso: '3050',
            country: 'ZAMBIA'
        },
        {
            value: '196',
            iso: '3051',
            country: 'ZIMBABWE'
        }
    ];
